"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));

var _react = _interopRequireWildcard(require("react"));

var _Dialog = _interopRequireDefault(require("../Dialog"));

var _classnames = _interopRequireDefault(require("classnames"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

var SuccessDialog = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(SuccessDialog, _Component);

  var _super = (0, _createSuper2["default"])(SuccessDialog);

  function SuccessDialog() {
    (0, _classCallCheck2["default"])(this, SuccessDialog);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(SuccessDialog, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _data = _this$props._data,
          name = _this$props.name,
          message = _this$props.message,
          information = _this$props.information;
      var iconClassName = (0, _classnames["default"])(_defaultModule["default"]['icon'], 'icon-crose');
      return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
        _data: _data,
        name: name
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _defaultModule["default"]['fail']
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _defaultModule["default"]['header']
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: iconClassName
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: _defaultModule["default"]['message'],
        "data-locator": "".concat(_data, ".message")
      }, message)), /*#__PURE__*/_react["default"].createElement("div", {
        className: _defaultModule["default"]['footer']
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: _defaultModule["default"]['info'],
        "data-locator": "".concat(_data, ".information")
      }, information))));
    }
  }]);
  return SuccessDialog;
}(_react.Component);

SuccessDialog.defaultProps = {
  _data: 'fail',
  name: 'fail',
  message: '',
  information: ''
};
var _default = SuccessDialog;
exports["default"] = _default;